const PHRASES = [
  "PRACTICE MAKES PERFECT",
  "CLOSE MORE DEALS",
  "SHARPEN YOUR PITCH",
  "HANDLE ANY OBJECTION",
];

export const Marquee = () => {
  const items = [...PHRASES, ...PHRASES];
  return (
    <section
      aria-hidden="true"
      className="relative overflow-hidden border-y border-white/5 py-10 select-none"
    >
      <div className="sp-marquee-track">
        {items.map((phrase, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading px-8 text-6xl font-black tracking-tighter text-white/[0.06] sm:text-8xl">
              {phrase}
            </span>
            <span className="text-4xl text-[#E52525]/40 sm:text-6xl">✳</span>
          </span>
        ))}
      </div>
    </section>
  );
};
